export const TicketUploadUID ='tktUploadIdentifier';